const RETURN_STUB = process.env.REACT_APP_STUBS_ENABLED === "true";

export const SampleStub = {
  create: (sample) =>
    RETURN_STUB && {
      data: {
        id: 1,
        display_id: 1,
        order_id: 1,
        sample_type: "Food",
        description: "Lumpia",
        tests: [
          {
            id: 1,
            display_id: 1,
            assay_id: 1,
            sample_id: 1,
            assay: { id: 18, title: "SPC", base_price: 20 },
          },
          {
            id: 2,
            display_id: 2,
            assay_id: 1,
            sample_id: 1,
            assay: { id: 18, title: "SPC", base_price: 20 },
          },
          {
            id: 3,
            display_id: 3,
            assay_id: 1,
            sample_id: 1,
            assay: { id: 18, title: "SPC", base_price: 20 },
          },
        ],
      },
    },
  get: (id) =>
    RETURN_STUB && {
      data: {
        id: 1,
        display_id: 1,
        order_id: 1,
        sample_type: "Food",
        description: "Lumpia",
        tests: [
          {
            id: 1,
            display_id: 1,
            assay_id: 1,
            sample_id: 1,
            assay: { id: 18, title: "SPC", base_price: 20 },
          },
          {
            id: 2,
            display_id: 2,
            assay_id: 1,
            sample_id: 1,
            assay: { id: 18, title: "SPC", base_price: 20 },
          },
          {
            id: 3,
            display_id: 3,
            assay_id: 1,
            sample_id: 1,
            assay: { id: 18, title: "SPC", base_price: 20 },
          },
        ],
      },
    },
  getByOrderId: (orderId) =>
    RETURN_STUB && {
      data: [
        {
          id: 1,
          display_id: 1,
          order_id: orderId,
          sample_type: "Food",
          description: "Lumpia",
          tests: [
            {
              id: 1,
              display_id: 1,
              assay_id: 1,
              sample_id: 1,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
            {
              id: 2,
              display_id: 2,
              assay_id: 1,
              sample_id: 1,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
            {
              id: 3,
              display_id: 3,
              assay_id: 1,
              sample_id: 1,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
          ],
        },
        {
          id: 2,
          display_id: 2,
          order_id: orderId,
          sample_type: "Food",
          description: "Pancit",
          tests: [
            {
              id: 4,
              display_id: 4,
              assay_id: 1,
              sample_id: 2,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
            {
              id: 5,
              display_id: 5,
              assay_id: 1,
              sample_id: 2,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
            {
              id: 6,
              display_id: 6,
              assay_id: 1,
              sample_id: 2,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
          ],
        },
        {
          id: 3,
          display_id: 3,
          order_id: orderId,
          sample_type: "Food",
          description: "Adobo",
          tests: [],
        },
        {
          id: 4,
          display_id: 4,
          order_id: orderId,
          sample_type: "Food",
          description: "Lechon",
          tests: [],
        },
      ],
    },
  update: (sample) => RETURN_STUB && { data: sample },
  delete: (id) => RETURN_STUB && { data: { message: "OK" } },
  all: (page = 1, pageSize = 20) =>
    RETURN_STUB && {
      data: [
        {
          id: 1,
          display_id: 1,
          order_id: 1,
          sample_type: "Food",
          description: "Lumpia",
          tests: [
            {
              id: 1,
              display_id: 1,
              assay_id: 1,
              sample_id: 1,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
            {
              id: 2,
              display_id: 2,
              assay_id: 1,
              sample_id: 1,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
            {
              id: 3,
              display_id: 3,
              assay_id: 1,
              sample_id: 1,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
          ],
        },
        {
          id: 2,
          display_id: 2,
          order_id: 1,
          sample_type: "Food",
          description: "Pancit",
          tests: [
            {
              id: 4,
              display_id: 4,
              assay_id: 1,
              sample_id: 2,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
            {
              id: 5,
              display_id: 5,
              assay_id: 1,
              sample_id: 2,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
            {
              id: 6,
              display_id: 6,
              assay_id: 1,
              sample_id: 2,
              assay: { id: 18, title: "SPC", base_price: 20 },
            },
          ],
        },
        {
          id: 3,
          display_id: 3,
          order_id: 2,
          sample_type: "Food",
          description: "Adobo",
          tests: [],
        },
        {
          id: 4,
          display_id: 4,
          order_id: 2,
          sample_type: "Food",
          description: "Lechon",
          tests: [],
        },
      ],
    },
  clone: (id) =>
    RETURN_STUB && {
      data: {
        id: 1,
        display_id: 1,
        order_id: 1,
        sample_type: "Food",
        description: "Lumpia",
        tests: [
          {
            id: 1,
            display_id: 1,
            assay_id: 1,
            sample_id: 1,
            assay: { id: 18, title: "SPC", base_price: 20 },
          },
          {
            id: 2,
            display_id: 2,
            assay_id: 1,
            sample_id: 1,
            assay: { id: 18, title: "SPC", base_price: 20 },
          },
          {
            id: 3,
            display_id: 3,
            assay_id: 1,
            sample_id: 1,
            assay: { id: 18, title: "SPC", base_price: 20 },
          },
        ],
      },
    },
};
